import { Button } from '@/components/atoms/Button/Button.styled';
import { TwoColContainer } from '@/components/atoms/TwoColContainer/TwoColContainer.styled';
import { medias } from '@/utils/sizes';
import styled from 'styled-components';
import { Column } from './FiltersSections/FiltersSections.styled';
import { generateClampFromMinMax } from '@/utils/styling';

export const RowMainFilters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AllFiltersContainer = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 100%;
  grid-column-start: 2;
  grid-column-gap: var(--spacing-component-inner);
  /* padding-bottom: var(--spacing-component-inner-sm); */
  height: min-content;

  ${medias.only.tablet} {
    position: relative;
    padding: 40px 0 20px;
  }

  ${Button} {
    position: relative;
    min-height: unset;
    line-height: 1;
    height: min-content;
    justify-content: flex-start;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: -10px;
      transform: translateY(-50%);
      width: 4px;
      height: 4px;
      border-radius: 10px;
      background-color: var(--c-font-primary);
      opacity: 0;
      transition: opacity var(--tr-base);
    }

    &.selected:before {
      opacity: 1;
    }

    ${medias.min.tablet} {
      &:hover span {
        color: var(--c-font-primary);
      }
    }

    ${medias.only.mobile} {
      span {
        font-size: var(--fs-lg);
      }
    }
  }
`;

export const FiltersContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['filtersContainerHeight', 'shouldDisplaySelectedFilters'].includes(prop),
})<{
  filtersContainerHeight: string;
  shouldDisplaySelectedFilters: boolean;
}>`
  position: relative;
  overflow: hidden;

  ${TwoColContainer}.container-filters-sections {
    overflow: hidden;
    transition: height var(--tr-base);
  }

  ${medias.only.tablet} {
    .info-results-container {
      position: absolute;
      height: var(--filter-row-height);

      .results-text {
        margin: auto 0;
        transform: translateY(0);
        transition: transform var(--tr-base);
      }
    }

    .filters-nav-container {
      gap: 4px;
    }

  }

  ${medias.min.tablet} {

    .two-col-container:first-child {
      margin-bottom: var(--spacing-component-inner-sm);
    }

    &[data-are-filters-open='false']
      ${TwoColContainer}.container-filters-sections {
      height: 0;
      border-color: transparent;
    }

    &[data-are-filters-open='true']
      ${TwoColContainer}.container-filters-sections {
      height: var(--filters-container-height);
      grid-template-rows: min-content;

      ${medias.only.tablet} {
        .results-text {
          transform: translateY(-9px);
        }
      }
    }

    &[data-display-selected-filters='true']
      ${TwoColContainer}.container-filters-sections {
      height: var(--filter-row-height);
      border-color: var(--c-border);
    }

    ${TwoColContainer}.container-filters-sections {
      transition: height var(--tr-base);
      padding-top: 0 !important;

      &:before,
      &:after {
        content: '';
        position: relative;
        display: block;
        width: 100%;
        height: var(--spacing-component-inner);
        grid-column: span 2;
      }
    }
  }

  ${medias.only.mobile} {
    box-sizing: border-box;
    position: fixed;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    height: 100vh;
    height: 100dvh;
    width: 100vw;
    background-color: var(--bg-main);
    padding: 0;
    z-index: 100;
    transform: translateX(-100%);
    transition: transform var(--tr-base);

    ${TwoColContainer} {
      padding-top: 0 !important;
      height: auto;
    }

    .container-filters-sections {
      height: min-content;
      overflow-y: auto !important;
      padding-top: 0 !important;
    }
    
    .info-results-container { 
      width: 100%;
    }

    .btn-apply-filters {
      position: relative;
      bottom: 0;
      left: 0;
      height: 51px;
      margin: var(--page-pd-mobile-tablet);
      width: calc(100% - (2 * var(--page-pd-mobile-tablet)));
      background: black;
      opacity: 1;
      transition: opacity var(--tr-base);

      &[data-are-filters-empty='true'] {
        opacity: 0.15;
        pointer-events: none;
      }

      ${medias.only.mobile} {
        margin-top: auto;
      }

      span {
        color: white;
        font-size: var(--fs-xl);
      }

      .filters-count {
        font-size: var(--fs-lg);
        margin-bottom: 3px;
        margin-left: 1px;
      }
    }

    &[data-are-filters-open='true'] {
      transform: translateX(0);
    }

    &[data-are-filters-open='false'] .container-filters-sections {
      height: auto;
      border-color: var(--c-border);
    }

    ${Column} {
      opacity: 1;
    }
  }
`;

export const AllFiltersColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(0, ${generateClampFromMinMax(220,450)})
  );

  grid-column-start: 1;
  grid-row-start: 1;

  ${medias.min.tablet} {
    // case with 4 columns with locations level 2 private mode:
    &[data-num-sections='4'] {
      grid-template-columns: repeat(4, 1fr);
    }

    &[data-num-sections='4']:has([data-filter-type="years"]) {
      grid-template-columns:
        repeat(2, minmax(0, ${generateClampFromMinMax(170, 458)})) 
        minmax(0, ${generateClampFromMinMax(170, 320)}) 
        minmax(0, ${generateClampFromMinMax(270, 500)});
      column-gap: 10px;

      ${medias.only.tablet} {
        grid-template-columns: 1fr 1fr 0.6fr 1.4fr !important;
        column-gap: 10px;
      }
    }
  }

  ${medias.only.tablet} {
    &[data-num-sections='3'] {
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 10px;
    }
  }

  ${medias.only.mobile} {
    grid-template-columns: 100%;
  }
`;

export const FiltersContent = styled.div`


`

export const FiltersHeadingMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  border-top: 1px solid var(--c-border);
  padding-top: 20px;
  /* padding-top: 20px;
  margin-top: -20px; */

  &[data-is-private-presentation='true'] {
    padding-top: 0;
    
    div,
    button {
      display: none;
    }

    & + div .container-filters-section {
      margin-bottom: 0;
    }
  }


  button {
    white-space: nowrap;
  }

  .typography {
    margin: auto 0;
    flex-direction: row;

    span {
      display: contents;
    }
  }

  .results-message {
    width: 100%;
    flex-basis: 100%;
    color: var(--c-font-secondary);

    span {
      color: var(--c-font-primary);
    }
  }
`;
